module.exports = __webpack_public_path__ + "img/b994141.jpg";